module.exports = __webpack_public_path__ + "img/flag-hover-pink.2206900a.svg";